import { createGlobalStyle } from 'styled-components';

//Globaltyle 사용해서 background-color사용
const GlobalStyle = createGlobalStyle`

body{
  background-color:#DB7093;
}
`;

export default GlobalStyle;
